import { LocaleMessages } from 'vue-i18n'

const authEnUsLocaleMessages: LocaleMessages = {
  login: {
    title: 'Login',
    alert: {
      loggedIn: 'You must be logged in to continue.'
    },
    notification: {
      entered: 'Successfully logged in.',
      exited: 'Successfully logged out.'
    },
    button: {
      goto: 'Go to Login'
    }
  },
  userRecovery: {
    title: 'Forgot your password?',
    alert: {
      sendEmail: 'Enter your email and we will send you a link to create a new password.'
    },
    notification: {
      sentEmail: 'Email successfully sent.'
    }
  },
  userRecoveryToken: {
    description: {
      confirmNewEmail: 'Confirm your new email',
      createPassword: 'Create your password'
    },
    alert: {
      expiredConfirmNewEmail: 'The link to confirm your new email has expired.',
      expiredCreatePassword: 'The link to create your password has expired. Do you want to send a new link to your email?'
    },
    notification: {
      confirmedNewEmail: 'New email successfully confirmed.',
      createdPassword: 'Password successfully created.'
    }
  },
  user: {
    title: 'User',
    pluralTitle: 'Users',
    field: {
      name: 'Name',
      email: 'Email',
      references: 'References',
      password: 'Password',
      newEmail: 'New email',
      newPassword: 'New password'
    }
  },
  group: {
    title: 'Group',
    pluralTitle: 'Groups',
    field: {
      name: 'Name',
      serial: 'Serial No.',
      references: 'References'
    }
  },
  module: {
    title: 'Module',
    pluralTitle: 'Modules'
  },
  access: {
    title: 'Access',
    pluralTitle: 'Accesses',
    field: {
      user: 'User',
      group: 'Group',
      module: 'Module',
      level: 'Level',
      startDate: 'Start Date',
      endDate: 'End Date',
      enabledLegacyAutologin: 'Automatic login'
    },
    value: {
      level: {
        ADMINISTRATOR: 'Administrator',
        MANAGER: 'Manager',
        OPERATOR: 'Operator',
        GUEST: 'Guest'
      }
    }
  }
}

export default authEnUsLocaleMessages